module.exports = __webpack_public_path__ + "img/_0.b0b9685d.png";